/**
 * Created by surajkumar on 16/12/16.
 */
/**
 * File contains a hashmap of hindi bad words, each word having a value of 1.
 */
var hindiBadWords = { "aand mat kaha": 1,
    "baap ke lavde": 1,
    chodu: 1,
    chodoo: 1,
    choodu: 1,
    gandu: 1,
    gaandu: 1,
    gandoo: 1,
    bhosad: 1,
    bhosada: 1,
    bhosadaa: 1,
    bhosadaaa: 1,
    bhosadii: 1,
    bhosadika: 1,
    bhosadike: 1,
    bhosadiki: 1,
    bosadike: 1,
    bakrichod: 1,
    balatkaar: 1,
    "behen ke laude": 1,
    betichod: 1,
    "bhai chhod": 1,
    "bhayee chod": 1,
    "bhen chhod": 1,
    bhaynchod: 1,
    behanchod: 1,
    behenchod: 1,
    "bhen ke lode": 1,
    bhosdi: 1,
    bhosdike: 1,
    "chipkai ki choot ke paseene": 1,
    "cha cha chod": 1,
    "chod ke bal ka kida": 1,
    "chopre he randi": 1,
    chudasi: 1,
    "chut ka maindak": 1,
    chutia: 1,
    chutiya: 1,
    chootia: 1,
    chutiye: 1,
    "dheeli choot": 1,
    choot: 1,
    chootiya: 1,
    "gaand chaat mera": 1,
    gaand: 1,
    "gaand ka khadda": 1,
    "gaand ke dhakan": 1,
    "gaand mein kida": 1,
    "gandi chut mein sadta hua ganda kida": 1,
    gandmasti: 1,
    "jhaat ke baal": 1,
    "jhat lahergaya": 1,
    jhatoo: 1,
    jhantu: 1,
    kukarchod: 1,
    "kutha sala": 1,
    "kuthta buraanahe kandaa nahi pattaahe": 1,
    "lode jesi shakal ke": 1,
    "lode ke baal": 1,
    "lund khajoor": 1,
    "lund chuse": 1,
    lund: 1,
    luhnd: 1,
    lundh: 1,
    "madar chod": 1,
    maadarchod: 1,
    maadar: 1,
    madar: 1,
    chod: 1,
    madarchod: 1,
    "madarchod ke aulaad": 1,
    "mader chod": 1,
    "mai chod": 1,
    "mera mume le": 1,
    "mere fudi kha ley": 1,
    "meri ghand ka baal": 1,
    randi: 1,
    "randi ka choda": 1,
    suzit: 1,
    "sust lund ki padaish": 1,
    "tatti ander lele": 1,
    "tere baap ki gaand": 1,
    "teri chute mai chuglee": 1,
    "teri gaand mein haathi ka lund": 1,
    "teri maa ki choot": 1,
    "teri maa ki sukhi bhos": 1,
    "teri phuphi ki choot mein": 1,
    "teri bhosri mein aag": 1,
    "teri gaand me danda": 1,
    "teri ma ki choot me bara sa land": 1,
    "teri ma ki chudaye bandar se hui": 1,
    "teri ma randi": 1,
    "teri maa ke bable": 1,
    "teri maa ke bhosade ke baal": 1,
    "tu tera maa ka lauda": 1,
    "amma ki chut": 1,
    "bhaand me jaao": 1,
    bhadva: 1,
    bhadve: 1,
    chodika: 1,
    "bhadwe ki nasal": 1,
    "bhen ke lode maa chuda": 1,
    "bhosad chod": 1,
    bhosadchod: 1,
    "bhosadi ke": 1,
    "bhosdee kay": 1,
    "bhosdi k": 1,
    "bulle ke baal": 1,
    bursungha: 1,
    camina: 1,
    "chod bhangra": 1,
    "choot k bhoot": 1,
    "choot k pakode": 1,
    "choot ka paani": 1,
    "choot ka pissu": 1,
    "choot ki jhilli": 1,
    chudpagal: 1,
    "chut ke makkhan": 1,
    chootiye: 1,
    "gaand maar bhen chod": 1,
    "gand mein louda": 1,
    "gandi fuddi ki gandi auladd": 1,
    "haram zaadaa": 1,
    harami: 1,
    jhaat: 1,
    "kaala lund": 1,
    "kaali kutti": 1,
    kuthri: 1,
    kutte: 1,
    "kutte ki olad": 1,
    "lavde ka baal": 1,
    lavde: 1,
    lodu: 1,
    "lowde ka bal": 1,
    "lund k laddu": 1,
    "lund mera muh tera": 1,
    "maa-cho": 1,
    "maal chhodna": 1,
    "mahder chod": 1,
    "mera gota moo may lay": 1,
    "mome ka pasina chat": 1,
    "moo may lay mera": 1,
    "padosi ki aulaad": 1,
    "rand ki moot": 1,
    "randi baj": 1,
    "randi ka larka": 1,
    "randi ke bacche": 1,
    "randi ke beej": 1,
    "saale lm": 1,
    "sab ka lund teri ma ki chut mein": 1,
    "sinak se paida hua": 1,
    "suvar chod": 1,
    "suwar ki aulad": 1,
    "tera gittha": 1,
    "tere maa ka bur": 1,
    "teri behen ka bhosda faadu": 1,
    "teri gand mai ghadhe ka lund": 1,
    "teri ma bahar chud rahi he": 1,
    "teri ma ko kutta chode": 1,
    "teri maa ka bhosra": 1,
    "teri maa ka boba chusu": 1,
    "teri maa ki choot me kutte ka lavda": 1,
    "teri maa ki chut": 1,
    "teri maa ki chute": 1,
    "tuzya aaichi kanda puchi": 1,
    bhadavya: 1,
    bhikaar: 1,
    bulli: 1,
    chinaal: 1,
    chut: 1,
    gand: 1,
    maadarbhagat: 1,
    chodubhagat: 1,
    lundfakir: 1,
    gandit: 1,
    jhavadya: 1,
    laudu: 1,
    lavadya: 1,
    muttha: 1,
    raandichya: 1,
    madarchoth: 1 };

module.exports = hindiBadWords;
